// extracted by mini-css-extract-plugin
export var contentBody = "_8l-9";
export var headerImage = "_8l-2";
export var imageButton = "_8l-7";
export var imageButtonIcon = "_8l-8";
export var imageHeader = "_8l-4";
export var imageHeaderText = "_8l-5";
export var imageOverlay = "_8l-3";
export var imageTitle = "_8l-6";
export var imageWrapper = "_8l-1";
export var taskList = "_8l-a";
export var widget = "_8l-0";